import React from "react";
import { Card, Stack, Typography, Chip, Button, Tooltip } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

export default function PendingCard({ row, onDownload, onOpenReview }) {
  return (
    <Card
      sx={{
        p: 1.5,
        borderRadius: 2,
        bgcolor: "background.paper",
        boxShadow: 4,
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle1" color="text.primary">
          {row.type} / {row.platform}
        </Typography>
        <Chip
          label={row.status?.toUpperCase()}
          color="warning"
          size="small"
          variant="outlined"
        />
      </Stack>

      <Typography
        variant="body2"
        sx={{ mt: 1, wordBreak: "break-all" }}
        color="text.secondary"
      >
        {row.video_url}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        User: {row.user_id?.username} ({row.user_id?.email})
      </Typography>
      <Typography variant="body2" color="text.secondary">
        User Spot USDT: <b>{row.user_spot_usdt_balance}</b>
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Created: {new Date(row.created_at).toLocaleString()}
      </Typography>

      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
        <Tooltip title="Download Screenshot">
          <span>
            <Button
              size="small"
              startIcon={<DownloadIcon />}
              onClick={() => onDownload(row)}
            >
              Download
            </Button>
          </span>
        </Tooltip>

        <Tooltip title="Review">
          <span>
            <Button
              size="small"
              variant="contained"
              onClick={() => onOpenReview(row)}
              sx={{
                bgcolor: "brand.main",
                "&:hover": { bgcolor: "brand.dark" },
              }}
            >
              Review
            </Button>
          </span>
        </Tooltip>
      </Stack>
    </Card>
  );
}
